function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5018 1.89195L16.4159 0L9.56086 6.21626L2.70575 0L0.619232 1.89195L9.56086 10L18.5018 1.89195Z",
  fill: "#70757A"
});

var SvgClickToCallArrow = function SvgClickToCallArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "assets/click-to-call-arrow.a6ec2c8a.svg";
export { SvgClickToCallArrow as ReactComponent };